// @flow
import type { NetInfoState } from '@react-native-community/netinfo';
import type { Action } from './types';

const initialState: NetInfoState = {
  type: 'none',
  isConnected: undefined,
  isInternetReachable: undefined,
  details: undefined,
  externalPublicIp: undefined,
};

const reducer = (state: NetInfoState = initialState, action: Action): NetInfoState => {
  const storedExternalPublicIp = state.externalPublicIp;

  switch (action.type) {
    case 'NETWORK_STATE_CHANGE':
      return { ...action.netInfo, externalPublicIp: storedExternalPublicIp };
    case 'INTERNET_STATE_CHANGE':
      return {
        ...state,
        isInternetReachable: action.isInternetReachable,
      };
    case 'APP_GOING_TO_BACKGROUND':
      return { ...initialState, externalPublicIp: storedExternalPublicIp };
    case 'SET_EXTERNAL_PUBLIC_IP':
      return {
        ...state,
        externalPublicIp: action.ip,
      };
    default:
      return state;
  }
};

export default reducer;
